import React, { useMemo } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button, Form, Modal } from "antd";
import { delPack, fetchInprogressAudios, fetchRefreshInProgress } from "../../../redux/JobModule/InProgressPage/InProgressAction";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useEffect } from "react";

interface DeleteJobModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function DeleteJobModal(props: DeleteJobModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  //Getting each packID
  const loading = useSelector((state: RootState) => state.InProgressAudiosState.delJobLoading);
  const currentRecord = useSelector((state: RootState) => state.InProgressAudiosState.currentRecord);
  const [error, setError] = React.useState<string>("");

  useEffect(() => {
    return () => {
      form.resetFields();
      setError("");
    };
  }, [props.openState]);
  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };

  const DeleteJobModalContent = useMemo(() => {
    const onFinish = async (value: any) => {
      try {
        await dispatch(delPack({ idPack: currentRecord.packId })).unwrap();

        handleModalClose();
        await dispatch(fetchRefreshInProgress({}));
      } catch (error: any) {
        setError("An error occurred while deleting the job. Please try again.");
      }
    };

    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content">
        <h4> Delete Job</h4>
        <p>
          <b> Are you sure you want to delete this job?</b> <br />
          <br />
          It will placed in the archive and deleted permanently after 30 days
        </p>
        {error && <div className="error justify-content-end align-self-end mb-2">{error}</div>}
        <div className="d-flex gap-3 justify-content-end">
          <Button
            style={{ color: "white", background: "#c00", boxShadow: "none" }}
            className="deleteButton"
            type="primary"
            htmlType="submit"
            loading={loading}
            onClick={onFinish}>
            Delete
          </Button>

          <Button
            className="cancelButton"
            htmlType="reset"
            loading={loading}
            onClick={handleModalClose}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }, [form, currentRecord, loading, error]);

  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        width={400}
        onCancel={handleModalClose}
        open={props.openState}>
        {DeleteJobModalContent}
      </Modal>
    </div>
  );
}

export default DeleteJobModal;
